import React from 'react'
import { Title, H, Represented, StateRepresented } from '../utils.tsx';
import * as settings from '../settings.js'

export const SexRepresentationText = ({ 
  data,
  userData
}: {
  data: Array<any>,
  userData: any
}) => {

  let ageGroupText: string
  let representationClass: string;
  
  const kings: number = data.executives.filter(e => e.sex === 'm').length;
  const queens: number = data.executives.filter(e => e.sex === 'w').length;

  const pKings: number = Math.round(100 / (kings + queens) * kings)
  const pQueens: number = Math.round(100 / (kings + queens) * queens)

  let percExec, percBev: number;

  if(userData.sex != '')
  {
    if(userData.sex === 'm')
    {
      percExec = pKings
      percBev = data.gender.m
    }
    else
    {
      percExec = pQueens
      percBev = data.gender.w
    }

    const toleranceMin = 5
    const toleranceMax = 15

    // Get Representation Class
    if(Math.abs(percExec - percBev) <= toleranceMin) representationClass = StateRepresented.good
    else if((percExec - percBev) > toleranceMax) representationClass = StateRepresented.stronglyOver
    else if((percExec - percBev) > toleranceMin) representationClass = StateRepresented.slightlyOver
    else if((percBev - percExec) > toleranceMax) representationClass = StateRepresented.stronglyUnder
    else if((percBev - percExec) > toleranceMin) representationClass = StateRepresented.slightlyUnder

    // Gett Representation Text
    if(representationClass === StateRepresented.good) ageGroupText = 'angemessen vertreten'
    else if(representationClass === StateRepresented.stronglyOver) ageGroupText = 'stark übervertreten'
    else if(representationClass === StateRepresented.slightlyOver) ageGroupText = 'übervertreten'
    else if(representationClass === StateRepresented.stronglyUnder) ageGroupText = 'stark untervertreten'
    else if(representationClass === StateRepresented.slightlyUnder) ageGroupText = 'untervertreten'
  }

  const userSexAdj: string = userData.sex === 'm' ? 'männlich' : 'weiblich'
  const userSexNom: string = userData.sex === 'm' ? 'Männer' : 'Frauen'

  const numberToWord = (n:Number, sex:string) => {
    if(n === 1)
      return 'einen'
    return n
  }

  return (
    <div className='userText'>

      <Title>Geschlecht</Title>
      {userData.sex != '' && <Represented state={representationClass}/>}

      {userData.sex != '' &&
        <>
          Betrachtet nach Ihrem Geschlecht sind Sie im {settings.executive[data.type].noun} von {data.name} <H>{ageGroupText}</H>. <H>Rund {percBev} Prozent</H>{' '}
          der Bevölkerung in {data.name} sind {userSexAdj}. In der Exekutive <H>halten {userSexNom}{' '}
          {numberToWord(userData.sex === 'm' ? kings : queens)} von deren {kings + queens} Sitzen, also{' '} rund {percExec} Prozent</H>.
        </>
      }
      
      {userData.sex === '' &&
        <>
          In {data.name}{' '}
          {kings === 1 ? <>regiert <H>ein Mann</H></> : <>regieren <H>{kings} Männer</H></>}
          {' '}<H>und</H>{' '}
          {queens === 1 ? <><H>eine Frau</H></> : <><H>{queens} Frauen</H></>}.{' '}
          Zum Vergleich: Die Bevölkerung in {data.name}{' '}
          besteht zu <H>{data.gender.m} Prozent aus Frauen</H>.
        </>
      }

    </div>
  )
}
